import React, { FC } from 'react'
import { Icon } from '@wmgtech/legato'

import isaacOpus from 'assets/images/logo-opus.png'
import { abbreviateNumber } from 'shared/utils'
import { ProjectMetricItem } from './Item'
import ProjectMetricsIsaak from './ProjectMetricsIsaakLinks'
import { IconName } from '@fortawesome/fontawesome-common-types'

import { IProjectMetrics } from './ProjectMetrics.props'

import './ProjectMetrics.scss'

const ProjectMetrics: FC<IProjectMetrics> = ({ isaacLinks, globalIsaakLinks, artist, projectMetricts  }) => (
  <div className="project-metrics">
    <div className="project-metrics__info">
      <h4 className="project-metrics__title">Artist Details</h4>
      <div className="project-metrics__content">
        {
          projectMetricts.map(({ icon, title, value }, idx) => (
            <ProjectMetricItem iconName={icon as IconName} title={title} value={value} key={idx}/>
          ))
        }
      </div>
    </div>
    <div className="project-metrics__info">
      <h4 className="project-metrics__title">Social Media</h4>

      <div className="project-metrics__content">
        <div className="project-metrics__socials">
          <a href={`https://www.facebook.com/${artist.facebook_id}`} rel="noreferrer" target="_blank">
            <Icon name="facebook-f" prefix="fab" />
          </a> {abbreviateNumber(artist.social_media_kpi_facebook)}
          <a href={`https://www.instagram.com/${artist.instagram_id}`} rel="noreferrer" target="_blank">
            <Icon name="instagram" prefix="fab" />
          </a> {abbreviateNumber(artist.social_media_kpi_instagram)}
          <a href={`https://twitter.com/${artist.twitter_id}`} rel="noreferrer" target="_blank">
            <Icon name="twitter" prefix="fab" />
          </a> {abbreviateNumber(artist.social_media_kpi_twitter)}
          <a href={`https://open.spotify.com/artist/${artist.spotify_id}`} rel="noreferrer" target="_blank">
            <Icon name="spotify" prefix="fab" />
          </a> {abbreviateNumber(artist.social_media_kpi_spotify)}
          <a href={`https://youtube.com/channel/${artist.youtube_id}`} rel="noreferrer" target="_blank">
            <Icon name="youtube" prefix="fab" />
          </a> {abbreviateNumber(artist.social_media_kpi_youtube)}
          <a href={`https://www.tiktok.com/${artist.tiktok_id}`} rel="noreferrer" target="_blank">
            <Icon name="tiktok" prefix="fab" />
          </a> {abbreviateNumber(artist.social_media_kpi_tiktok)}
          <a href={`https://opus.wmg.com/entity/artist/${artist.opus_id}/social`} className="project-metrics__opus">
            <img className="opus__logo" src={isaacOpus} alt="OPUS Logo" />
          </a>
        </div>
      </div>
      <ProjectMetricsIsaak isaacLinks={isaacLinks} title="Local ISAAC links" />
      <ProjectMetricsIsaak isaacLinks={globalIsaakLinks} title="Global ISAAC links"/>
    </div>
  </div>
)

export default ProjectMetrics
